export default __webpack_public_path__ + "static/media/clipboard-white.39fe95c2.svg";